import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getQuickAccessDetailApi = createAsyncThunk(
    'quickAccess/detail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.quickAccessAction(id, 1));
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

const getQuickAccessDetailSlice = createSlice({
    name: 'quickAccessDetail',
    initialState: { result: {}, loading: false, error: null, message: "" },
    reducers: {
        resetQuickAccessDetail: (state) => {
            state.result = {};
            state.loading = false;
            state.error = null;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getQuickAccessDetailApi.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getQuickAccessDetailApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
        });
        builder.addCase(getQuickAccessDetailApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
        });
    },
});

export const { resetQuickAccessDetail } = getQuickAccessDetailSlice.actions;
export const getQuickAccessDetailReducer = getQuickAccessDetailSlice.reducer;
